import { DateAdapter } from "../DateAdapter";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const REQUESTED_FIXING_TIME_COLUMN_PROPERTY = "reqFixingTime";
export const REQUESTED_FIXING_DATE_COLUMN_PROPERTY = "reqFixingDate";
export const REQUESTED_FIXING_TIMEZONE_COLUMN_PROPERTY = "reqFixingTzCd";
export const FIXING_DATE_COLUMN_PROPERTY = "fixingDate";
export const MOMENT_DATE_FORMAT_STRING = "YYYY-MM-DD HH:mm:ss.SSS";

/**
 * NOTE: still in development, bugs when showing dates from next year
 */
export class FixingTimeAdapter extends DateAdapter {
  protected timeFormat = "HH:mm";
  protected dateFormat = "DD-MMM-YY";
  protected timezoneUTC = "UTC";
  protected convertToUTC = false;
  protected fullDateTimeUTC = false;

  static transformDateStringToMomentFormatString(dateString: string, timeString: string): string {
    return CubiqTS.moment(dateString + "T" + timeString).format(MOMENT_DATE_FORMAT_STRING);
  }

  static getFixingDetailsProperty(order: any, columnProperty): any {
    if (order.fixingDetails != null) {
      return order.fixingDetails[columnProperty];
    } else if (order[columnProperty] != null) {
      return order[columnProperty];
    }
    return null;
  }

  constructor(format?: string, convertToUTC?: boolean, fullDateTimeUTC?: boolean) {
    super(format);
    this.convertToUTC = convertToUTC;
    this.fullDateTimeUTC = fullDateTimeUTC;
  }

  protected getFixingTimeValue(order: any, columnProperty: any): string {
    let fixingDate: CubiqTS.Moment = order[FIXING_DATE_COLUMN_PROPERTY];
    let reqFixingTimeProperty = FixingTimeAdapter.getFixingDetailsProperty(
      order,
      REQUESTED_FIXING_TIME_COLUMN_PROPERTY,
    );
    let reqFixingDateProperty = FixingTimeAdapter.getFixingDetailsProperty(
      order,
      REQUESTED_FIXING_DATE_COLUMN_PROPERTY,
    );
    let reqTimeZoneCodeProperty: any = FixingTimeAdapter.getFixingDetailsProperty(
      order,
      REQUESTED_FIXING_TIMEZONE_COLUMN_PROPERTY,
    );
    let reqFormattedDateProperty: string = CubiqTS.moment(reqFixingDateProperty).format(
      this.dateFormat,
    );
    let reqFixingDateFull: string = FixingTimeAdapter.transformDateStringToMomentFormatString(
      reqFixingDateProperty,
      reqFixingTimeProperty,
    );
    if (this.convertToUTC) {
      if (this.fullDateTimeUTC) {
        reqFormattedDateProperty = CubiqTS.moment.utc(fixingDate).format(this.dateFormat);
        return (
          CubiqTS.moment.utc(fixingDate).format(this.timeFormat) +
          " " +
          this.timezoneUTC +
          " " +
          reqFormattedDateProperty
        );
      }
      return CubiqTS.moment.utc(fixingDate).format(this.timeFormat);
    }

    if (reqFixingDateFull) {
      return (
        CubiqTS.moment.utc(reqFixingDateFull).format(this.timeFormat) +
        " " +
        reqTimeZoneCodeProperty
      );
    }
    return "-";
  }

  retrieveData(order: any, columnProperty: string): string {
    return this.getFixingTimeValue(order, columnProperty);
  }
}
